import React from 'react';

import ModalNoSuccess from '../Modals/ModalNoSuccess';

type ProfileActionsModalProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export function ProfileActionsModal({
  isOpen,
  setIsOpen,
}: ProfileActionsModalProps) {
  return (
    <ModalNoSuccess
      dialogTitle="Profile Actions"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      cancelButtonText="Close"
    >
      <div className="space-y-3 mt-3">
        <div className="text-sm text-neutral-600">
          <span className="font-semibold">Delete profile:</span>
          &nbsp;Permanently removes this profile and logs the user our of the
          Tapt app. The user will longer be able to access or use their profile.
        </div>
        <div className="text-sm text-neutral-600">
          <span className="font-semibold">Clear profile:</span>
          &nbsp;Removes all profile details but keeps the profile available for
          future reuse.
        </div>
      </div>
    </ModalNoSuccess>
  );
}
